import { Asset } from '@/api/generatedApi';
import { HeaderText } from '@/components/HeaderText';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { Box, Divider } from '@mui/material';
import { SupplementalAssetsAddButton } from './SupplementalAssetsAddButton';
import { SupplementalAssetsList } from './SupplementalAssetsList';

export const SupplementalAssets = ({ asset }: { asset?: Asset }) => {
  const { isSupplementalAssetsEnabled } = useFeatureFlags();

  if (!asset || !isSupplementalAssetsEnabled) {
    return;
  }

  return (
    <>
      <Box display='flex' alignItems='center' justifyContent='space-between' margin='2px 8px 2px 0'>
        <HeaderText sx={{ margin: '4px 8px' }}>Supplemental Assets</HeaderText>
        <SupplementalAssetsAction asset={asset} />
      </Box>

      {asset.hasSupplementalAssets && <Divider />}
      <SupplementalAssetsList asset={asset} />
    </>
  );
};

const SupplementalAssetsAction = ({ asset }: { asset?: Asset }) => {
  return asset !== undefined && <SupplementalAssetsAddButton asset={asset} />;
};
